export default __webpack_public_path__ + "static/media/5691a440493b00bbbaa8b1c1f8d5a243.svg";